import { render, staticRenderFns } from "./GridColumn.vue?vue&type=template&id=079e12d5&"
import script from "./GridColumn.vue?vue&type=script&lang=js&"
export * from "./GridColumn.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/grid-column.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports